module.exports = __webpack_public_path__ + "img/especiais.fc3d9601.svg";